module.exports = __webpack_public_path__ + "static/media/1.751a409c.png";